import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '@app/services/toast.service';
import { EncryptionService } from '../../services/encryption.service';
import { DealerService } from '../../services/dealer.service';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-payment-status',
    templateUrl: './payment-status.component.html',
    styleUrl: './payment-status.component.scss',})
export class PaymentStatusComponent {
  gateway_name: string = '';
  ref_num: string = '';
  orderStatus: string = ''
  orderNumbers: string[] = [];
  userType: string | null = '';

  constructor(private route: ActivatedRoute,
    private dealerService: DealerService,
    private router: Router,
    private toastr: ToastService,
    private encryptionService: EncryptionService) {

  }
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.gateway_name = params['gateway_name'] || '';
      this.ref_num = params['razorpay_payment_id'];
      if (params['razorpay_payment_link_status']) {
        this.orderStatus = params['razorpay_payment_link_status'].toLowerCase() || '';
      }
      const orderNumbersParam = params['o_n'] || '';
      if (orderNumbersParam) {
        this.orderNumbers = orderNumbersParam.split(',').map((o: any) => o.trim());
      }
    });
    // this.dealerService.setOrder(this.orderNumbers[0]);

    this.userType = this.encryptionService.getFromLocalStorage('user_type');
    if (this.userType === 'dealer' && this.orderNumbers[0]) {
      setTimeout(() => {
        this.router.navigate([`/dealer/order/payment-details/${this.orderNumbers[0]}`]);
      }, 5000); // 10 seconds delay
  }
}
copyReferenceNo(refer: string): void {
  navigator.clipboard.writeText(refer).then(() => {
    this.toastr.success(`Reference number ${refer} copied to clipboard!`);
  }).catch(err => {
    console.error('Failed to copy Reference number:', err);
  });
}
}
